import axios from 'axios'
import {PersonMetaImplEnumTO, PersonMetaTO, PersonPhotoTO, PersonTO} from 'generated/JavaTO'

export const PERSONS_URL = "../json/persons";
export const PERSONS_PREFETCH_URL = "../json/persons/partialPrefetch";

export function getPersonPhotosAPI(persNrList: number[]) {
	return axios.get<PersonPhotoTO[]>('../json/person/photo', {params: {persNrList}})
}

export interface PersonMetaParams {
	impl: PersonMetaImplEnumTO
	startDate?: number | null
	startTime?: number | null
	endDate?: number | null
	endTime?: number | null
}

export function getPersonMetaListAPI({impl, startDate, startTime, endDate, endTime}: PersonMetaParams) {
	return axios.get<PersonMetaTO[]>('../json/persons/meta', {
		params: {
			impl,
			startDate: startDate || null,
			startTime: startTime || null,
			endDate: endDate || null,
			endTime: endTime || null,
		},
	})
}

export function getPersonBookingEndDataApi(persNr: number) {
	return axios.get<PersonTO>('../json/person/' + persNr);
}